import { dayDictionary } from "core/times";
import { PopupInfo, Programme } from "core/types";
import ListItemComponent from "./list-item";
import programmeWrapper from "core/lib/programme-wrapper";
import dateTimeWrapper from "core/lib/date-time-wrapper";

type ListForDatesProps = {
    date: string;
    programmes: Programme[];
    setShowPopup: (value: boolean) => void;
    setPopupInfo: (value: PopupInfo | undefined) => void;
}

const ListForDates = (props: ListForDatesProps) => {
    const { date, programmes, setShowPopup, setPopupInfo } = props;

    const [day, month, dayNumber,] = date.split(" ");
    const key = day as keyof typeof dayDictionary;

    const currentDateTime = dateTimeWrapper();

    const Header = () => {
        return (
            <div
                className="schedule-item date-item"
                key={date}>
                <span className="date-portion">
                    {`${dayNumber} ${month}`}
                </span>
                <span className="day-portion">
                    {dayDictionary[key]}
                </span>
            </div>
        );
    }

    const lastIndex = programmes.length - 1;

    return (
        <>
            <Header />
            {
                programmes.map((programme, index) => {
                    //is next programme current which means this is the the previous programme
                    //to the current one
                    const isLastItem = index === lastIndex;
                    const nextProgramme = isLastItem ? null : programmes[index + 1];
                    const isLastProgram = !isLastItem
                        && nextProgramme !== null
                        && programmeWrapper(nextProgramme).isCurrent(currentDateTime.datetime);

                    return (
                        <ListItemComponent
                            key={programme.id + index}
                            programme={programme}
                            currentDateTime={currentDateTime}
                            isLastProgram={isLastProgram}
                            setShowPopup={setShowPopup}
                            setPopupInfo={setPopupInfo} />
                    );
                })
            }
        </>
    );
}

export default ListForDates